import clsx from "clsx";
import React from "react";

interface SectionProps {
  background?: string;
  name?: string;
  noPadding?: boolean;
  smallPadding?: boolean;
}

export const Section: React.FC<SectionProps> = ({
  background = "white",
  children,
  noPadding = false,
  smallPadding = false,
  name
}) => {
  const classes = clsx(
    "section",
    `section--${background}`,
    {
      "section--no-padding": noPadding,
      "section--small-padding": smallPadding
    },
    name ? `section--${name}` : ""
  );
  return (
    <section id={name} className={classes}>
      {children}
    </section>
  );
};
